import { render } from "./ParaClipper.vue?vue&type=template&id=4a06c4a0&scoped=true"
import script from "./ParaClipper.vue?vue&type=script&lang=js"
export * from "./ParaClipper.vue?vue&type=script&lang=js"

import "./ParaClipper.vue?vue&type=style&index=0&id=4a06c4a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a06c4a0"]])

export default __exports__